import BigNumber from 'bignumber.js'
import { DEFAULT_GAS_LIMIT, DEFAULT_TOKEN_DECIMAL } from 'config'
import getGasPrice from 'utils/getGasPrice'

const options = {
  gasLimit: DEFAULT_GAS_LIMIT,
}

const usdcConAdds = {
  '43113': '0x5425890298aed601595a70AB815c96711a31Bc65',
  '43114': '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E'
}

export const buyXP = async (
  xpMerchantContract,
  walletAddress,
  price,
  amount
) => {
  const gasPrice = getGasPrice()

  const response = await fetch(`.netlify/functions/xm-signatures-get?walletAddress=${walletAddress}&price=${price}&amount=${amount}`, {
    headers: {
      security: walletAddress
    }
  });
  const {signature, currentTimestamp} = await response.json();
// console.log("Debugging buyXP call:");
// console.log("walletAddress:", walletAddress);
// console.log("paymentToken:", usdcConAdds[process.env.REACT_APP_PUBLIC_CHAIN_ID]);
// console.log("price:", price);
// console.log("amount:", amount);
// console.log("timestamp:", currentTimestamp);
// console.log("signature:", signature);
  try {
    const tx = await xpMerchantContract.buyXP(
      walletAddress,
      usdcConAdds[process.env.REACT_APP_PUBLIC_CHAIN_ID],
      price,
      amount,
      currentTimestamp,
      signature,
      // {}
      { ...options, gasPrice }
      // { gasLimit: gasPrice }
    );
    const receipt = await tx.wait();
    return receipt.status;
  } catch (error) {
    console.error("Transaction failed:", error);
  }
}

//////////////////////////////////////////////////////////////////////
export const unlockXp = async (xpContract, amount) => {
  const gasPrice = getGasPrice()

  const tx = await xpContract.unlock(amount, { ...options, gasPrice })
  const receipt = await tx.wait()
  return receipt.status
}


export const mintXpUnlockWrapper = async (
  xpUnlockWrapperContract,
  walletAddress,
  nexItemId,
  price,
  amount
) => {
  const gasPrice = getGasPrice()
  var _userMaxMintSupply;

  var endpoint;
  if(nexItemId === 'GLITCH'){
    endpoint = 'g-signatures-get'
    _userMaxMintSupply = '5';
  }else{
    endpoint = 'ni-signatures-get'
    _userMaxMintSupply = '2';
  }


  const response = await fetch(`.netlify/functions/${endpoint}?walletAddress=${walletAddress}&nexItemId=${nexItemId}&price=${price}`, {
    headers: {
      security: walletAddress
    }
  });
  const {signature, currentTimestamp} = await response.json();
// console.log(
//   walletAddress,
//   nexItemId,
//   amount,
//   price,
//   currentTimestamp,
//   signature
// )

  var tx;
  if(nexItemId === 'GLITCH'){
    tx = await xpUnlockWrapperContract.mintLockedXpGLITCH(
      amount,
      _userMaxMintSupply,
      price,
      currentTimestamp,
      signature,
      {}
    )
  }else{
    tx = await xpUnlockWrapperContract.mintNexItemsLockedXp(
      nexItemId,
      amount,
      _userMaxMintSupply,
      price,
      currentTimestamp,
      signature,
      {}
    )
  }

  const receipt = await tx.wait()
  return receipt.status
}
